import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  author?: string;
  publishedTime?: string;
  schema?: object;
}

export const SEO = ({
  title = "Rob Lasa",
  description = "One man's honest record of what happens when you stop performing. For my sons. For any man who sees himself in it.",
  keywords = "nice guy syndrome, men's mental health, honest masculinity, identity, self-honesty",
  image = "/og-image-new.jpg",
  url = "https://souldadrob.com",
  type = "website",
  author = "Rob Lasa",
  publishedTime,
  schema
}: SEOProps) => {
  const fullTitle = title.includes('|') || title === 'Rob Lasa' || title.toLowerCase().startsWith('rob lasa')
    ? title
    : `${title} | Rob Lasa`;
  const fullUrl = url.startsWith('http') ? url : `https://souldadrob.com${url}`;
  const fullImage = image.startsWith('http') ? image : `https://souldadrob.com${image}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={fullUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Rob Lasa" />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      <meta name="twitter:creator" content="@souldadrob" />

      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};
